import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { EstadoPagare, Pagare } from 'app/models/pagare.model';
import { ConsultaExternoHeader } from 'app/models/report.model';
import { CarpetaService } from 'app/services/carpeta.service';
import { ExcelApi } from 'app/models/excel.model';
import { ExcelService } from 'app/services/excel.service';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { firstValueFrom, take } from 'rxjs';
import { ExternoService } from 'app/services/externo.service';
import { EstadoHtml } from 'app/shared/estado-html';

@Component({
    selector: 'consulta',
    templateUrl: './consulta.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ConsultaComponent {
    constructor(
        private route: Router,
        private _externoService: ExternoService,
        private _excelService: ExcelService
    ) {
        this.header = { TOTAL: 0, MONTO_TOTAL: 0, IMPUESTO_TOTAL: 0 };
    }
    selected = '1';
    date = new FormControl(new Date());
    showModalPreview: boolean = false;

    columns: TableColumn[] = [
        {
            columnDef: 'FOLIO',
            header: 'FOLIO',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'RUTDV',
            header: 'RUT',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'NOMBRE_ESTADO',
            header: 'ESTADO',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'flex items-center gap-2',
            columnType: 'custom',
            columnFormat: '',
            columnSort: true,
            columFunction: this.printEstado,
        },
        {
            columnDef: 'FECHA_CREACION',
            header: 'FECHA OTORGAMIENTO',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'paragraph-4',
            columnType: 'date',
            columnFormat: 'dd/MM/YYYY',
            columnSort: true,
        },
        {
            columnDef: 'MONTO_TOTAL',
            header: 'MONTO FINANCIADO',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'paragraph-4',
            columnType: 'currency',
            columnFormat: 'CLP',
            columnSort: true,
        },
        {
            columnDef: 'NRO_CONTRATO',
            header: 'N° CONTRATO',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'FOLIO_CUOTA',
            header: 'N° DOC TRIBUTARIO',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnType: 'custom',
            columnClassMobile: 'flex items-center gap-2',
            columnFormat: '',
            columnSort: true,
            columFunction: this.replace,
        },
        {
            columnDef: 'IMEI',
            header: 'IMEI',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnType: 'string',
            columnClassMobile: 'paragraph-4',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'IMPUESTO',
            header: 'MONTO IMPUESTO ($)',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'paragraph-4',
            columnType: 'currency',
            columnFormat: 'CLP',
            columnSort: true,
        },
        {
            columnDef: 'FOLIO_ACELERADA',
            header: 'FOLIO FACTURA ACELERADA',
            headerClass: 'px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
    ];

    displayedColumns: string[] = [
        'folio',
        'rut',
        'estado',
        'fechaOtorgamiento',
        'montoFinanciado',
        'contrato',
        'tributario',
        'imei',
        'montoImpuesto',
        'FFcuotaMensual',
        'FFacelerada',
    ];

    selection = new SelectionModel<any>(true, []);

    search: string = '';
    currentSearch: string = '';
    start: moment.Moment = moment().add(-30, 'd');
    end: moment.Moment = moment();

    header: ConsultaExternoHeader;
    dataSource: Pagare[] = [];
    loadingExcel: boolean = false;

    estadosPagare: EstadoPagare[] = [];
    estadoSelected: number = 0;

    async ngOnInit() {
        this.estadoSelected = await this.listarEstados();
        this.listar();
    }

    async listarEstados() {
        let estado = 0;
        this.estadosPagare = await firstValueFrom(this._externoService.listarEstadosPagare());
        if (this.estadosPagare.length > 0) {
            estado = 0;
            this.estadosPagare.unshift({
                ID_ESTADO: 0,
                NOMBRE_ESTADO: 'TODOS',
            });
        }
        return estado;
    }

    listar() {
        if (this.start && this.end) {
            let start = this.start.format('yyyy-MM-DD');
            let end = this.end.format('yyyy-MM-DD');
            this._externoService
                .getPagares(this.currentSearch, this.estadoSelected, start, end)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.dataSource = data.DETAIL;
                        this.header = data.HEADER;
                    },
                    error: (err: any) => {
                        console.log(err);
                        this.dataSource = [];
                        this.header = { TOTAL: 0, MONTO_TOTAL: 0, IMPUESTO_TOTAL: 0 };
                    },
                    complete: () => {},
                });
        }
    }

    dateRangeChange($event: any, dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        this.listar();
    }

    onTableAction(row: any) {
        console.log(row);
        this._externoService.getDocumento(row.FOLIO).subscribe((data) => {
            var downloadURL = window.URL.createObjectURL(data);
            window.open(downloadURL, '_blank');
        });
    }

    replace(row: any, attribute: string): string {
        return row.FOLIO_CUOTA.replaceAll('|', '-');
    }

    printEstado(row: any, attribute: string): string {
        console.log(row.ID_ESTADO);
        let estadoHtml = new EstadoHtml();
        return estadoHtml.generate(row.ID_ESTADO);
    }

    descargarExcel() {
        let excel: ExcelApi = {
            config: {
                workSheetName: 'ConsultaExternos',
                columns: [
                    { tittle: 'FOLIO', type: 'number', dataKey: 'FOLIO', width: 20 },
                    { tittle: 'RUT', type: 'string', dataKey: 'RUTDV', width: 20 },
                    { tittle: 'ESTADO', type: 'string', dataKey: 'NOMBRE_ESTADO', width: 20 },
                    { tittle: 'FECHA OTORGAMIENTO', type: 'string', dataKey: 'FECHA_CONTRATO', width: 30 },
                    { tittle: 'MONTO FINANCIADO', type: 'number', dataKey: 'MONTO_TOTAL', width: 20 },
                    { tittle: 'N° CONTRATO', type: 'string', dataKey: 'NRO_CONTRATO', width: 30 },
                    { tittle: 'N° DOC TRIBUTARIO', type: 'string', dataKey: 'FOLIO_CUOTA', width: 30 },
                    { tittle: 'IMEI', type: 'string', dataKey: 'IMEI', width: 20 },
                    { tittle: 'IMPUESTO', type: 'number', dataKey: 'IMPUESTO', width: 20 },
                    { tittle: 'FOLIO_ACELERADA', type: 'string', dataKey: 'FOLIO_ACELERADA', width: 20 },
                ],
            },
            arrData: this.dataSource,
        };
        if (excel.arrData.length > 0) {
            this.loadingExcel = true;
            this._excelService.generarExcel(excel).subscribe({
                next: (resp) => {
                    saveAs(resp.body, 'ConsultaExternos');
                    this.loadingExcel = false;
                },
                error: (err) => {
                    //console.log('Err Excel');
                    //console.log(err);
                    this.loadingExcel = false;
                },
                complete: () => {},
            });
        }
    }
}
